<template>
    <div class="border bg-white dark:bg-gray-800 rounded-lg shadow p-4">
        <h2 class="mb-4">Links</h2>

        <Btn
            content="+"
            class="mt-3"
            type="button"
            @click="addLink"
            :disabled="disabled"
        />

        <draggable
            v-model="links"
            @input="data => $emit('input', data)"
            handle=".handle"
            :disabled="disabled"
            @choose="froalaStore.disableFroala = true"
            @unchoose="froalaStore.disableFroala = false"
        >
            <div
                v-for="(link, index) in links"
                :key="`link-${link.uuid}`"
                class="mt-3 relative"
            >
                <Btn
                    content="-"
                    class="bg-red-400 absolute top-1 right-1 z-50"
                    type="button"
                    @click="() => deleteLink(index)"
                />

                <div v-if="links.length > 1"
                      class="handle pr-1 text-gray-400 dark:text-gray-200 hover:text-gray-600 dark:hover:text-gray-400 cursor-pointer transition duration-150 transform hover:scale-105 absolute top-1 right-12 px-4 py-3 z-50"
                      title="Drag to reorder items">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 17l-4 4m0 0l-4-4m4 4V3" />
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7l4-4m0 0l4 4m-4-4v18" />
                    </svg>
                </div>

                <rocket-link
                    :language="language"
                    :disabled="disabled"
                    :resettable="resettable"
                    :label="label"
                    :link-types="linkTypes"
                    :linkable-types="linkableTypes"
                    :hide-link-text="hideLinkText"
                    v-model="links[index]"
                />
            </div>
        </draggable>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import reference from "../../mixins/reference";
import {v4 as uuidv4} from 'uuid';
import {useFroalaStore} from "../../stores/froala";

export default {
    name: "RocketLinks",
    components: {draggable},
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        resettable: {
            type: Boolean,
            required: false,
            default: false,
        },
        value: {
            type: Array,
            required: false,
        },
        label: {
            type: String,
            required: false,
            default: 'Link',
        },
        language: {
            type: Object,
            required: true,
        },
        errors: {
            type: [Array, Object],
            required: false,
        },
        min: {
            type: Number,
            required: false,
            default: 0,
        },
        max: {
            type: Number,
            required: false,
            default: null,
        },
        linkTypes: {
            type: Array, // Array of link type ids: [1, 3, 4]
            required: false,
            default: () => [1, 2, 3, 4],
        },
        linkableTypes: {
            type: Array, // Array of data types
            required: false,
            default: () => [
                'All Category',
                'Casino Review',
                'Slot Review',
                'Game Review',
                'Home Page',
                'About Us Page',
                'Author',
                'Legal Notice Page',
                'Privacy Policy Page',
                'Cookie Policy Page',
                'Responsible Gambling Page',
                'Payment Method Main Page',
                'License Main Page',
                'Knowledge Hub Page',
                'Blog Main Page',
                'Guide Main Page',
                'Trust Page',
                'Blog',
                'Guide',
                'Html Sitemap',
            ],
            validator: (types) => {
                return types.filter(type => ! Object.hasOwn(reference.data().contentTypes, type)).length === 0;
            },
        },
        hideLinkText: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    mounted: function () {
        if (this.value) {
            this.links = this.value.map(e => {
                e.uuid = uuidv4();
                return e;
            }) || [];
        }
    },
    methods: {
        addLink () {
          this.links = [...this.links, {
              uuid: uuidv4(),
          }];
        },
        deleteLink (index) {
            let links = [...this.links];
            links.splice(index, 1);
            this.links = links;
        },
    },
    computed: {
    },
    data(){
        return {
            links: [],
            froalaStore: useFroalaStore(),
        }
    },
    watch: {
        links: function (newValue) {
            this.$emit('input', newValue);
        },
    },
}
</script>
